import React from 'react';
import styled from 'styled-components';

const ShippingBoxSection = styled.div`
  margin: 0.5rem 0;
  display: flex;
  justify-content: center;
`;

export default ({ className, ...rest }) => <ShippingBoxSection className={className} {...rest} />;
